<ng-container *transloco="let _t">

<ul>
	<li *ngFor="let user of showedUsers; let u=index;" (click)="add(user)"
	[ngStyle]="{
		'background-color': getUserColor(user.name),
		'border-size': isSelected(user) ? '2px' : '1px'
	}">{{user.name}}
	</li>
</ul>
<p class="text-right">
	<br>
	<button mat-raised-button (click)="close()" color="disabled">
		{{ _t('Annuler') }}
	</button>
</p>

</ng-container>